import { render, staticRenderFns } from "./billsPaymentCategoryForm.vue?vue&type=template&id=5c8cd01d"
import script from "./billsPaymentCategoryForm.vue?vue&type=script&lang=js"
export * from "./billsPaymentCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports